/**
 * @generated SignedSource<<9e703aca89ddc6ca8add2f8f11d68439>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AskFellowHooksSetConversationContextMutation$variables = {
  contextId?: string | null;
  conversationId: string;
  filters?: string | null;
};
export type AskFellowHooksSetConversationContextMutation$data = {
  readonly setContextForAskCopilotConversation: {
    readonly conversation: {
      readonly suggestedQuestions: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion">;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"AskFellowContext_conversation">;
    };
  } | null;
};
export type AskFellowHooksSetConversationContextMutation = {
  response: AskFellowHooksSetConversationContextMutation$data;
  variables: AskFellowHooksSetConversationContextMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contextId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "conversationId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filters"
},
v3 = [
  {
    "kind": "Variable",
    "name": "contextId",
    "variableName": "contextId"
  },
  {
    "kind": "Variable",
    "name": "conversationId",
    "variableName": "conversationId"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AskFellowHooksSetConversationContextMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SetContextForAskCopilotConversation",
        "kind": "LinkedField",
        "name": "setContextForAskCopilotConversation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AskCopilotConversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AskFellowContext_conversation"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SuggestedQuestion",
                "kind": "LinkedField",
                "name": "suggestedQuestions",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "AskFellowHooksSetConversationContextMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "SetContextForAskCopilotConversation",
        "kind": "LinkedField",
        "name": "setContextForAskCopilotConversation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AskCopilotConversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AskCopilotConversationContext",
                "kind": "LinkedField",
                "name": "context",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "filters",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SuggestedQuestion",
                "kind": "LinkedField",
                "name": "suggestedQuestions",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contentForDisplay",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "41e0e4f6616516b2a66bc44f82cf6d0d",
    "id": null,
    "metadata": {},
    "name": "AskFellowHooksSetConversationContextMutation",
    "operationKind": "mutation",
    "text": "mutation AskFellowHooksSetConversationContextMutation(\n  $conversationId: ID!\n  $contextId: ID\n  $filters: JSONString\n) {\n  setContextForAskCopilotConversation(conversationId: $conversationId, contextId: $contextId, filters: $filters) {\n    conversation {\n      ...AskFellowContext_conversation\n      suggestedQuestions {\n        id\n        ...AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion\n      }\n      id\n    }\n  }\n}\n\nfragment AskFellowContext_conversation on AskCopilotConversation {\n  id\n  context {\n    name\n    filters\n  }\n}\n\nfragment AskFellowSuggestedQuestions_SuggestedQuestionButton_suggestedQuestion on SuggestedQuestion {\n  id\n  content\n  contentForDisplay\n}\n"
  }
};
})();

(node as any).hash = "ee976df07ab74047ded5ce9842b34063";

export default node;
